import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

import { GUEST_KEY } from '@makyoapp/makyo-common'
import { AvatarCell, AvatarSize, SelectDropdown } from '@makyoapp/makyo-ui'

interface LayoutUserDropdownProps {
  options: any[]
  value: string
  onChange(value: string): void
}

export function LayoutUserDropdown({ options, value, onChange }: LayoutUserDropdownProps) {
  const { t } = useTranslation()

  return (
    <SelectDropdown
      toggleClassName={clsx('min-w-[200px] py-1! text-m-sm')}
      outlined={false}
      value={options.find((opt) => opt.id === value) || options[0]}
      withSearch={true}
      onChange={(opt, e) => {
        onChange(opt.id === GUEST_KEY ? '' : opt.id)
      }}
      options={options}
      optionLabel={(opt) => {
        return [opt.name, opt.email].join(' ')
      }}
      renderOption={(opt, inToggle) => {
        if (inToggle) {
          return (
            <AvatarCell
              fallbackError
              size={AvatarSize.XS}
              src={opt.photo}
              textClassName='txt'
              {...opt}
              renderTitle={(title) => {
                if (title === 'Guest') {
                  return t('{{name}} / Logged-Out', {
                    name: title,
                  })
                }
                return t('Viewing as {{name}}', {
                  name: title,
                })
              }}
            />
          )
        } else {
          return (
            <AvatarCell
              fallbackError
              src={opt.photo}
              size={AvatarSize.XS}
              {...opt}
              renderTitle={(title) => {
                if (title === 'Guest') {
                  return t('{{name}} / Logged-Out', {
                    name: title,
                  })
                }
                return title
              }}
            />
          )
        }
      }}
    />
  )
}
